import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";

import DropDown from "../../../../../../../Components/DropDown/DropDown";
import AddButton from "../../../../../../../Components/AddButton/AddButton";
import { TextView } from "../../../../../../../Components/TextView";
import { DetailChip } from "../../../../DetailTab";

const InsuranceSelectionTpa = ({
  setInsuranceDetails,
  insurances,
  tpas,
  insuranceDetails,
  insuranceData,
  isEditable,
}) => {
  const handleAddInsuranceTPA = () => {
    setInsuranceDetails((prevState) => ({
      ...prevState,
      insuranceTPAs: [...prevState.insuranceTPAs, { insuranceId: 0, tpaId: 0 }],
    }));
  };

  const handleDeleteInsuranceTPA = (index) => {
    setInsuranceDetails((prevState) => ({
      ...prevState,
      insuranceTPAs: prevState.insuranceTPAs.filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <Grid container item lg={12} marginY={"30px"}>
        {insuranceDetails.insuranceTPAs.map((tpa, index) => (
          <React.Fragment key={index}>
            <Grid item lg={4}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                }}>
                Choose Insurance
              </Typography>
              {isEditable ? (
                <DropDown
                  viewHeight={"44px"}
                  borderRadius={"5px"}
                  bgColor="white"
                  border="2px solid #e9eff7"
                  viewWidth="60%"
                  handleSelected={(e, value) => {
                    setInsuranceDetails((prevState) => ({
                      ...prevState,
                      insuranceTPAs: prevState.insuranceTPAs.map((tpa, i) =>
                        i === index ? { ...tpa, insuranceId: value?.id } : tpa
                      ),
                    }));
                  }}
                  placeholder="Choose Insurance"
                  data={insurances}
                  value={insuranceDetails?.insurances}
                />
              ) : (
                <>
                  {insuranceData.insuranceTPAResponses.map((data, index) => (
                    <DetailChip
                      color={"#effef5"}
                      border={"1px solid #65dec7"}
                      value={data.insurance.insuranceName}></DetailChip>
                  ))}
                </>
              )}
            </Grid>
            <Grid item lg={4}>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "#4c5a6a",
                  paddingBottom: "7px",
                }}>
                Choose TPA
              </Typography>
              {isEditable ? (
                <DropDown
                  viewHeight={"44px"}
                  borderRadius={"5px"}
                  bgColor="white"
                  border="2px solid #e9eff7"
                  viewWidth="60%"
                  handleSelected={(e, value) => {
                    setInsuranceDetails((prevState) => ({
                      ...prevState,
                      insuranceTPAs: prevState.insuranceTPAs.map((tpa, i) =>
                        i === index ? { ...tpa, tpaId: value?.id } : tpa
                      ),
                    }));
                  }}
                  placeholder="Choose TPA"
                  data={tpas}
                  // value={insuranceDetails.insuranceTPAs[index]?.tpaId}
                  value={insuranceDetails?.tpas}
                />
              ) : (
                <>
                  {insuranceData.insuranceTPAResponses.map((data, index) => (
                    // <TextView key={index}>{data.tpa.name}</TextView>
                    <DetailChip
                      color={"#effef5"}
                      border={"1px solid #65dec7"}
                      value={data.tpa.name}></DetailChip>
                  ))}
                </>
              )}
            </Grid>

            {isEditable && (
              <IconButton
                onClick={() => handleDeleteInsuranceTPA(index)}
                aria-label="comment">
                <CloseIcon />
              </IconButton>
            )}
          </React.Fragment>
        ))}
      </Grid>
      <Box>
        <Grid item lg={12} justifyContent={"flex-end"} marginTop={"30px"}>
          {isEditable && (
            <Grid item lg={1.1}>
              <AddButton
                onClick={handleAddInsuranceTPA}
                labelName={"Add New Insurance"}
                viewHeight={"45px"}
                width={'180px'}
                borderRadius={"5px"}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default InsuranceSelectionTpa;
